export const vs2jen2VersionListConstants = {
  VS2JEN2VERSION_LIST_LOADING: "VS2JEN2VERSION_LIST_LOADING",
  VS2JEN2VERSION_LIST_SUCCESS: "VS2JEN2VERSION_LIST_SUCCESS",
  VS2JEN2VERSION_LIST_FAILURE: "VS2JEN2VERSION_LIST_FAILURE",
};

export const vs2jen2VersionUploadConstants = {
  VS2JEN2VERSION_UPLOAD_LOADING: "VS2JEN2VERSION_UPLOAD_LOADING",
  VS2JEN2VERSION_UPLOAD_SUCCESS: "VS2JEN2VERSION_UPLOAD_SUCCESS",
  VS2JEN2VERSION_UPLOAD_FAILURE: "VS2JEN2VERSION_UPLOAD_FAILURE",
};

export const vs2jen2VersionConstants = {
  VS2JEN2VERSION_LOADING: "VS2JEN2VERSION_LOADING",
  VS2JEN2VERSION_SUCCESS: "VS2JEN2VERSION_SUCCESS",
  VS2JEN2VERSION_FAILURE: "VS2JEN2VERSION_FAILURE",
};

export const vs2jen2VersionDeleteConstants = {
  VS2JEN2VERSION_DELETE_LOADING: "VS2JEN2VERSION_DELETE_LOADING",
  VS2JEN2VERSION_DELETE_SUCCESS: "VS2JEN2VERSION_DELETE_SUCCESS",
  VS2JEN2VERSION_DELETE_FAILURE: "VS2JEN2VERSION_DELETE_FAILURE",
};
